import Vue from "vue";
import Vuex from "vuex";

import { account } from "./account";
import { user } from "./user";
import { apTemplate } from "./apTemplate";
import { ap } from "./ap";
import { language } from "./language";
import { question } from "./question";
import { answer } from "./answer";
import { region } from "./region";
import { apFinalized } from "./apFinalized";
import { closureQuestion } from "./closureQuestion";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    ap,
    account,
    user,
    apTemplate,
    language,
    question,
    answer,
    region,
    apFinalized,
    closureQuestion

  }
});
